module.exports = __webpack_public_path__ + "c1c09b296df000fd064aacb10d4499cd.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Bold.svg
// module id = 349
// module chunks = 0